var ezdia;
(function (ezdia) {
    function tabNavPillsArrow(direction) {
        return "<div class=\"nav-pills-arrow-" + direction + " hide\" data-arrow=\"" + direction + "\">\n      <a href=\"javascript:void(0)\"  data-toggle=\"dropdown\">\n        <i class=\"fa fa-circle\"></i><i class=\"fa fa-circle\"></i><i class=\"fa fa-circle\"></i>\n      </a>\n      <ul class=\"dropdown-menu\"></ul>\n    </div>";
    }
    function chartWrappers(chartsIds) {
        return chartsIds
            .map(function (_a) {
            var id = _a.id, classes = _a.classes, type = _a.type;
            return "<div id=\"" + id + "\" class=\"ez-dashboard-reporting-chart ez-dashboard-" + type + " " + classes + "\" data-chart=\"" + type + "\"></div>";
        })
            .join('');
    }
    function tabsMarkup(tabs) {
        var e_1, _a;
        var tabsHtmlContentArray = [];
        var paneHtmlContentArray = [];
        try {
            for (var _b = __values(Object.entries(tabs)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), tab = _d[1];
                var _e = tab, label = _e.label, name_1 = _e.name, id = _e.id, chartsIds = _e.chartsIds, filters = _e.filters, tooltip = _e.tooltip;
                var helperTextContent = '';
                if (tooltip) {
                    helperTextContent = "<div id=\"" + id + "__od\" class=\"optional-descriptive-tab\">" + tooltip + "</div>";
                }
                var tabHtmlContent = "<li>\n        <a href=\"#" + id + "\" data-name=\"" + name_1 + "\" data-not=\"tab\">" + label + "</a>\n      </li>";
                var paneHtmlContent = "<div class=\"tab-pane \" id=\"" + id + "\">\n        " + tabSearch(id, filters) + "\n        <div class=\"charts-panel-wrapper col-layout-" + chartsIds.length + "\">\n          " + chartWrappers(chartsIds) + helperTextContent + "\n        </div>\n        " + helperTextContent + "\n      </div>";
                tabsHtmlContentArray.push(tabHtmlContent);
                paneHtmlContentArray.push(paneHtmlContent);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var tabsHtmlContent = "<div class=\"ez-scroll-nav-pills\" id=\"ez-scroll-nav-pills\">\n      " + tabNavPillsArrow('left') + "\n      <div data-nav=\"scroll\" class=\"ez-nav-scroll-inner\">\n        <ul class=\"nav ez-nav-pills\">\n          " + tabsHtmlContentArray.join("<li><i class=\"fa fa-long-arrow-right\"></i></li>") + "\n        </ul>\n      </div>\n      " + tabNavPillsArrow('right') + "\n    </div>";
        return {
            tabsHtmlContent: tabsHtmlContent,
            panesHtmlContent: paneHtmlContentArray.join('')
        };
    }
    function getDescription(id, description) {
        return "<a\n      id=\"" + id + "__info\"\n      class=\"btn btn-circle-icon btn-default\"\n      href=\"javascript:\"\n      tabindex=\"0\"\n      role=\"button\"\n      data-placement=\"bottom\"\n      data-helper=\"helper\"\n      data-content=\"" + description + "\"\n    >\n      <i class=\"fa fa-info-circle\"></i>\n    </a>";
    }
    function search(id, filter) {
        var e_2, _a;
        var htmlContentArray = [];
        var htmlContent = '';
        if (filter && filter.length) {
            try {
                for (var filter_1 = __values(filter), filter_1_1 = filter_1.next(); !filter_1_1.done; filter_1_1 = filter_1.next()) {
                    var column = filter_1_1.value;
                    var type = column.type, value = column.value, label = column.label;
                    column.editable = true;
                    column.edittype = type;
                    column.id = ezdia.util.makeId();
                    var inputContent = $.ezdia.inputs.create({ column: column, value: value });
                    htmlContentArray.push("<div class=\"filter-group\">\n          <label class=\"filter-label\">" + label + "</label>\n          <div>" + inputContent + "</div>\n        </div>");
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (filter_1_1 && !filter_1_1.done && (_a = filter_1.return)) _a.call(filter_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            htmlContent = "<form class=\"disable\" id=\"" + id + "__search-form\">\n        " + htmlContentArray.join('') + "\n      </form>";
        }
        return htmlContent;
    }
    function getTabFilterOptions(colModel) {
        var e_3, _a;
        var config = colModel.config, name = colModel.name;
        var configObj;
        if (typeof config === 'string') {
            configObj = ezdia.util.jsonParse(config);
        }
        else {
            configObj = config;
        }
        var extendoptions = $.extend({ '': 'All' }, configObj.options);
        var htmlContent = [];
        var checked = true;
        try {
            for (var _b = __values(Object.entries(extendoptions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), value = _d[0], label = _d[1];
                var id = ezdia.util.makeId();
                htmlContent.push("<li>\n        <input\n          id=\"" + id + "\"\n          type=\"radio\"\n          name=\"" + name + "\"\n          value=\"" + value + "\"\n          " + (checked ? "checked=\"checked\"" : '') + "\n        />\n        <label\n          class=\"\"\n          for=\"" + id + "\"\n        >" + label + "</label>\n      </li>");
                checked = false;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return htmlContent.join('');
    }
    function tabSearch(id, filter) {
        var htmlContent = '';
        if (filter && filter.length) {
            var column = filter[0];
            column.id = ezdia.util.makeId();
            htmlContent = "<div class=\"ez-dashboard-pane-tab\">\n        <form class=\"basic-search-rows\" id=\"" + id + "__search-form\">\n          <ul class=\"list-inline radio-tab\">" + getTabFilterOptions(column) + "</ul>\n        </form>\n      </div>";
        }
        return htmlContent;
    }
    function panel(props, tabs) {
        var _a = tabsMarkup(tabs), tabsHtmlContent = _a.tabsHtmlContent, panesHtmlContent = _a.panesHtmlContent;
        var id = props.id, title = props.title, tooltip = props.tooltip, description = props.description, filter = props.filter;
        return "<div id=\"" + id + "\" class=\"reporting-chart-wrapper\">\n      <div class=\"dashboard-panel\" data-row=\"wrapper\">\n        <div class=\"panel-heading ez-normal-font\" data-toggle=\"collapse\">\n          <div id=\"ez-grp-heading-generic\">\n            " + title + getDescription(id, description) + "\n          </div>\n          <div class=\"panel-actions\"></div>\n          <div class=\"inline-chart-action\" data-form=\"search\">\n            " + search(id, filter) + "\n          </div>\n          <div class=\"panel-tabs\">\n            <div id=\"" + id + "__tabs\" class=\"ez-scroll-nav-pills-form disable\">\n              <div class=\"table-cell ez-chart-tabs\">" + tabsHtmlContent + "</div>\n            </div>\n          </div>\n        </div>\n        <div class=\"panel-body ez-dashboard-charts ez-tab-container not-grid generic collapse in \" data-row=\"body\">\n          <div id=\"" + id + "__content\" class=\"ez-tab-content tab-content\">" + panesHtmlContent + "</div>\n          " + (tooltip ? "<div class=\"optional-descriptive\">" + tooltip + "</div>" : '') + "\n        </div>\n      </div>\n    </div>";
    }
    function requestMarkup(_a) {
        var status = _a.status, btnId = _a.btnId, panelId = _a.panelId, msg = _a.msg, imagePlaceholder = _a.image_placeholder;
        return "<div\n      id=\"" + panelId + "\"\n      class=\"ez-dashboard-roc-req text-center\"\n      style=\"background-image: url(" + imagePlaceholder + ") \"\n    >\n      " + (!status
            ? "<button id=" + btnId + " type=\"button\" class=\"btn btn-success\">Request ROCS Analysis</button>"
            : requestPendingMarkup(msg)) + "\n    </div>";
    }
    function requestPendingMarkup(msg) {
        var textMsg = msg ||
            "Your request has been submitted to eZdia. A representative will contact you shortly.";
        return "<div class=\"alert alert-success\">\n      " + textMsg + "\n    </div>";
    }
    var templates;
    (function (templates) {
        var charts;
        (function (charts) {
            charts.rocs = {
                panel: panel,
                requestMarkup: requestMarkup,
                requestPendingMarkup: requestPendingMarkup,
                getTabFilterOptions: getTabFilterOptions
            };
        })(charts = templates.charts || (templates.charts = {}));
    })(templates = ezdia.templates || (ezdia.templates = {}));
})(ezdia || (ezdia = {}));
